import request from "root/js/request";

const getUnitEconomyMultiTableOzon = async ({
  date_to,
  date_from,
  group_by,
  order_by,
  q,
  limit,
  offset,
  product_cost__isnull,
  gross_margin__lt,
  gross_margin_to_realization_price_share__gt,
  gross_margin_to_realization_price_share__lt,
  gross_margin_to_cost_share__lt,
  gross_margin_to_cost_share__gt,
  categories,
  subject_id__in,
  brands,
  product_id__icontains,
  supplier_article,
  wb_api_key_ids,
  ...rest
}) => {
  const response = await request({
    url: "/ozon_analytics/unit_economy_multi_table/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      group_by,
      limit,
      offset,
      q,
      product_cost__isnull,
      order_by,
      gross_margin__lt,
      gross_margin_to_realization_price_share__gt,
      gross_margin_to_realization_price_share__lt,
      gross_margin_to_cost_share__lt,
      gross_margin_to_cost_share__gt,
      category_id__in: categories,
      subject_id__in,
      brand_id__in: brands,
      product_id__icontains,
      supplier_article,
      ...rest,
    },
  });
  return response.data;
};

export { getUnitEconomyMultiTableOzon };
